import axios, { AxiosError } from 'axios';
import { ApiFinanceira } from '../axiosfinanceiro';

interface ContasRecebidas {
  parceiro: string;
  cpf: string;
  fazenda: string;
  historico: string;
  cultivo: string;
  numerodoc: string;
  dataoperacao: Date;
  conta: string;
  valor: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const RelatorioContasRecebidas = async (parceiro: string, fazenda: string, cultivo: string, datainicial: string, datafinal: string): Promise<ContasRecebidas[] | Error> => {
  try {
    const urlRelativa = `/relatoriocontasrecebidas?fazenda=${fazenda}&parceiro=${parceiro}&cultivo=${cultivo}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
  
export const RelatorioContasRecebidasService = {
  RelatorioContasRecebidas
};